<template>
  <div class="card-skill">
    <!-- <v-img :src="require('../../' + img)" width="150px"></v-img> -->
    <div class="text-h6 title-text">
      {{ title }}
    </div>

    <div class="text-body-1">
      {{ description }}
    </div>
  </div>
</template>

<script>
export default {
  props: {
    img: {
      type: String,
      required: true
    },
    title: {
      type: String,
      required: true
    },
    description: {
      type: String,
      required: true
    }
    // project: Object
  }
}
</script>

<style lang="scss" scoped>
@import '@/theme/variables.scss';
.card-skill {
  border-radius: 1px;

  max-width: 450px;
  min-height: 190px;
  padding: 30px;

  margin: 10px;

  border: 1px solid rgba(128, 128, 128, 0.2);
}

.title-text {
  padding-bottom: 35px;
}
</style>
